export const BuyProposalStatus = Object.freeze({
    P: Symbol('P'),
    A: Symbol('A'),
    R: Symbol('R'),
    C: Symbol('C'),
});

export function getStatusText(status) {
    return {
        [BuyProposalStatus.P]: 'Złożona',
        [BuyProposalStatus.A]: 'Zaakceptowana',
        [BuyProposalStatus.R]: 'Odrzucona',
        [BuyProposalStatus.C]: 'Anulowana',
    }[BuyProposalStatus[status]];
}